var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "parent_div", attrs: { id: "ms_header_downside" } },
    [
      _c("dd-header"),
      _vm._v(" "),
      _c("h2", { staticClass: "hakotan_title" }, [
        _vm._v("プライバシーポリシー")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper" }, [
        _c(
          "div",
          { staticClass: "main_content" },
          [
            _c("dd-menu", { ref: "menuRef" }),
            _vm._v(" "),
            _c("div", { attrs: { id: "tokutei" } }, [
              _c("section", [
                _c("div", { ref: "corp_yasumoku", staticClass: "corp_table" }, [
                  _vm._m(0)
                ])
              ])
            ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("dd-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "ul_corp_outline" }, [
      _c("li", [
        _c("div", [_vm._v("はじめに")]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "株式会社ヤスモク（以下「当社」）は、個人情報保護の重要性を認識し、適切に利用し、保護することが社会的責任であると考え、個人情報の保護に努めることをお約束いたします。"
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("個人情報の定義")]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "個人情報とは、個人に関する情報であり、氏名、生年月日、性別、電話番号、電子メールアドレス、職業、勤務先等、特定の個人を識別し得る情報をいいます。"
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("個人情報の収集・利用")]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "\n                  当社は、以下の目的のため、その範囲内においてのみ、個人情報を収集・利用いたします。"
          ),
          _c("br"),
          _vm._v(
            "\n                  当社による個人情報の収集・利用は、お客様の自発的な提供によるものであり、お客様が個人情報を提供された場合は、当社が本方針に則って個人情報を利用することをお客様が許諾したものとします。"
          ),
          _c("br"),
          _vm._v(
            "\n                  ・ご注文された当社の商品をお届けするうえで必要な業務"
          ),
          _c("br"),
          _vm._v(
            "\n                  ・新商品の案内など、お客様に有益かつ必要と思われる情報の提供"
          ),
          _c("br"),
          _vm._v(
            "\n                  ・業務遂行上で必要となる当社からの問い合わせ、確認、およびサービス向上のための意見収集"
          ),
          _c("br"),
          _vm._v(
            "\n                  ・不正・不当な目的で当社を利用しようとする方のご利用をお断りするために行う調査"
          ),
          _c("br"),
          _vm._v(
            "\n                  ・当社及び当社の提携先が提供しているサービスやセキュリティの向上"
          ),
          _c("br"),
          _vm._v(
            "\n                  ・各種のお問い合わせ対応\n                "
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("個人情報の第三者提供")]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "当社は、法令に基づく場合等正当な理由によらない限り、事前に本人の同意を得ることなく、個人情報を第三者に開示・提供することはありません。"
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("委託先の監督")]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "当社は、お客様へ商品やサービスを提供する等の業務遂行上、個人情報の一部を外部の委託先へ提供する場合があります。その場合、業務委託先が適切に個人情報を取り扱うように管理いたします。"
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("個人情報の管理")]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "当社は、個人情報の漏洩、滅失、毀損等を防止するために、個人情報保護管理責任者を設置し、十分な安全保護に努め、また、個人情報を正確に、また最新なものに保つよう、お預かりした個人情報の適切な管理を行います。"
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("クッキーについて")]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "当ウェブサイトでは、クッキーを商品の購入、利用者の動向調査等の為に使用することがあります。お客様がクッキーを使用しない設定としている場合、当ウェブサイトで使用できる機能については制限される可能性がありますのでご了承下さい。"
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [_vm._v("情報内容の照会、修正または削除")]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "当社は、お客様が当社にご提供いただいた個人情報の照会、修正または削除を希望される場合は、ご本人であることを確認させていただいたうえで、合理的な範囲ですみやかに対応させていただきます。"
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b1d518e8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b1d518e8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/hakotan/pages/DcPrivacyPolicy.vue
// module id = null
// module chunks = 